import React from "react";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

const SSSkeletonSx = {
  fontSize: "1.5rem",
  width: "100%",
};

const SSItemOrderSkeletonRow = {
  ml: 4.5,
  mb: 1,
  height: "24px",
  alignItems: "center",
};

export default function SSInlineItemLoader() {
  return (
    <>
      <Grid
        container
        columnGap={0.5}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={0.15}>
          <Skeleton variant="circular" sx={{ width: "15px", height: "15px" }} />
        </Grid>
        <Grid item xs={2.2}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.45}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.3}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.3}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.3}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.8}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.8}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.8}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.8}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={0.4}>
          <Skeleton variant="text" sx={{ ...SSSkeletonSx, width: "70%" }} />
        </Grid>
      </Grid>
      <Grid
        container
        columnGap={0.5}
        alignItems="center"
        justifyContent="flex-start"
        sx={SSItemOrderSkeletonRow}
      >
        <Grid item xs={1.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={1.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={1.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
        <Grid item xs={1.5}>
          <Skeleton variant="text" sx={SSSkeletonSx} />
        </Grid>
      </Grid>
    </>
  );
}
